import { Box, Button, Grid, Modal, TextField, Typography } from '@mui/material';
import { useState } from 'react';

import { IModal } from '../../../../interfaces/modal.interface';

const styles = {
  modalContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { sm: 600, xs: '100%' },
    bgcolor: 'background.paper',
    borderRadius: { sm: '0.5rem', xs: 0 },
    boxShadow: 24,
    overflowY: 'visible',
    p: 4,
  },

  confirmLogoutFormTitle: { marginBottom: '0.5rem' },

  modalListContainer: {
    marginTop: '1rem',
    display: 'flex',
    justifyContent: 'space-between',
    paddingY: '0.5rem',
  },

  modalListItem: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  modalCloseButton: {
    padding: '0.5rem 3rem',
    borderRadius: '2.5rem',
    width: { sm: 'auto', xs: '100%' },
  },
};

const ConfirmationModal = ({ isModalOpen, title, message, isRemarks, onClickModal }: IModal) => {
  const [remarks, setRemarks] = useState<string>();

  return (
    <Modal open={isModalOpen}>
      <Box sx={styles.modalContainer}>
        <Box>
          <Typography sx={{ fontSize: '1.75rem' }} color='primary'>
            {title}
          </Typography>

          <Typography sx={{ marginY: '2rem' }}>{message}</Typography>

          {isRemarks && (
            <Grid container>
              <Grid item xs={12} sx={{ mb: '2rem' }}>
                <TextField
                  fullWidth
                  label='Remarks'
                  multiline
                  rows={4}
                  value={remarks}
                  onChange={(e) => {
                    setRemarks(() => e.target.value);
                  }}
                />
              </Grid>
            </Grid>
          )}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ ...styles.modalCloseButton, mr: '1rem' }}
            onClick={() => onClickModal('confirm', remarks)}
            disableElevation
            disabled={isRemarks && !remarks ? true : false}
          >
            Confirm
          </Button>

          <Button
            color='inherit'
            variant='contained'
            sx={styles.modalCloseButton}
            onClick={() => onClickModal('cancel')}
            disableElevation
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
